/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Nalaganje ...',
	'dlg_close': 'Zapri',
	'dlg_ok': 'V redu',
	'dlg_cancel': 'Prekliči',
	'dlg_back': 'Pojdi nazaj',
	'dlg_done': 'Opravljeno',

	// Slider
	'sliderRegionLabel': 'Kontrolnik drsnika, za pomik ročk drsnika uporabite puščice desno in levo',
	'sliderHandleLabel': 'Ročka drsnika',
	'a11ySliderHandleLabel': 'Ročka drsnika %{sliderValue}',
	'sliderInputLabel': 'vrednost',

	// Side bar
	'sidebarAdd': 'Dodaj',
	'clearTextFilterValue': 'Počisti',
	'missingDataSetData': 'Podatki za ta nabor podatkov niso na voljo. Osvežite nabor podatkov ali pa se za dostop do izvora obrnite na skrbnika.',

	// Toolbar
	'toolbarRegionLabel': 'Orodna vrstica',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Družina pisav',
	'fontSizeSelect': 'Velikost pisave',
	'fontColorSelect': 'Barva',
	'fontStyle': 'Slog',
	'colorPickerTitle': 'Izbiranje barve',
	'bold': 'Krepko',
	'italic': 'Ležeče',
	'underline': 'Podčrtano',
	'fontAlignment': 'Poravnava',
	'justifyLeft': 'Poravnaj levo',
	'justifyCenter': 'Poravnaj na sredino',
	'justifyRight': 'Poravnaj desno',
	'insertOrderedList': 'Urejen seznam',
	'insertUnorderedList': 'Neurejen seznam',
	'fontColorPicker': 'Izbirnik barv',
	'textWrap': 'Oblij besedilo',
	'restore': 'Obnovi privzeto',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Število rezultatov (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Odstotek (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Možnost zgoraj ali spodaj',
	'topbottomOptionLabel': 'Pokaži',
	'searchByLabel': 'Po',
	'searchNoMatches': 'Najdeno ni bilo nobeno ujemanje',
	'topbottomRankColumnLabel': 'Dodaj stolpec ranga v tabelo',
	'topbottomNone': 'Brez',
	'topCount': 'Število zgornjih',
	'topPercent': '% zgornjih',
	'bottomCount': 'Število spodnjih',
	'bottomPercent': '% spodnjih',
	'searchColumn': 'Najdi stolpec',
	'searchColumnAriaLabel': 'Najdite stolpec. Vnesite ime stolpca, ki ga želite poiskati, nato pa s puščico navzdol poiščite stolpec na seznamu',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Ponastavi',

	// Format
	'formatAuto': 'Samodejno',
	'formatConvertPercent': 'Pretvori decimalke v odstotke',
	'formatAbbreviate': 'Okrajšano',
	'formatUseGrouping': 'Uporabi ločilo tisočic',
	'dateStyle': 'Slog datuma',
	'dateTimeStyle': 'Slog datuma/časa',
	'formatMissingValueCharactersInfo': 'Znaki manjkajočih vrednosti podajajo znake, ki bodo prikazani, če vrednost manjka.',
	'currencySymbolLabel': 'Valutni simbol',
	'customSymbolPlaceholder': 'Dodaj simbol',
	'customSymbolLabelInfo': 'Podaja znak ali znake, ki bodo uporabljeni kot simbol po meri. Ta simbol bo pred številko in drugimi morebitnimi znaki.',
	'numberLabel': 'Oznaka številke',
	'numberPositionLabel': 'Položaj oznake',
	'numberLabelInfo': 'Podaja oznako za oblikovano številko, ki je postavljena kot predpona ali pripona, odvisno od položaja oznake.',
	'nullValueDefault': '<privzeto>',
	'nullValueContent': '(brez vrednosti)',
	'default': 'Privzeto',
	'beginning': 'Začetek',
	'end': 'Konec',
	'formatLabel': 'Izberite obliko',

	// More data indicator
	'moreDataIndicator': 'Podatki so bili obrezani pri naslednjem št. postavk: %{threshold}. Uveljavite filter, da se prikaže manj zadetkov.',

	// Expanded View / Focus mode
	'evCollapse': 'Strni',
	'duplicate': 'Podvoji',
	'copyOf': 'Kopija %{name}',
	'unableToDuplicateBoard': '"%{name}" ni mogoče podvojiti.',

	// Widget list
	'errorLoadingWidgetList': 'Objektov ni mogoče naložiti.',

	// Custom widgets
	'customWidget': 'Gradnik po meri'
});
